<template>
  <div class="tabdeclinedVue">
    <!-- Individual calls section area -->
        <div class="o-ndividualArea c-responsive-fixwidth">

            <div class="o-ndividualTable" v-loading="loading">

                <div class="o-schedule-decline ">

                    <div v-for="(decline,index) in declinedList" :key="index" class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table">

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Event:</span></p>
                                    <p><a href="javascript: void(0)">{{(decline.call && decline.call.job)? decline.call.job.title : ''}}</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="skill-details-box">
                                    <div class="">
                                        <div class="schedule-details-box">
                                            <p><span>Call Date:</span></p>
                                            <p>{{getDate(decline.call.called_at)}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Call:</span></p>
                                    <p>{{getTime(decline.call.start)+" - "+getTime(decline.call.end)}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Position:</span></p>
                                    <p>{{decline.call.skill.name}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Initiator:</span></p>
                                    <p>{{decline.first_name+" "+decline.last_name}} <br/> ({{ getGlobalDateTimeFormat(decline.updated_at) +")"}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Status:</span></p>
                                    <p>{{decline.status.name}}</p>
                                </div>
                            </div>
                        </div>
                        
                        <!-- <div v-if="getPower('unDeclinedCall') && decline.status.name !='Passed'" class="schedule-box-left"> Timed Out-->
                        <div v-if="userRoleSlug != 'employee' && decline.status.name !='Passed' && decline.status.name !='Timed Out'" class="schedule-box-left">
                            <div class="skill-details">
                            <!--  Check the user {{'- '+userRoleSlug+' - '+getPower('unDeclinedCall')+' - '+(userRoleSlug != 'employee') }} -->
                                <div class="schedule-details-box text-center">
                                    <a href="javascript: void(0)" @click="undeclinedCall(decline)" class="c-common-btn c-common-btn--small">Undeclined</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="declinedList.length <= 0 && afterAPI" class="">
                        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                            <div class="col-md-12 no-job-dispaly">
                               <!-- <i class="fa fa-frown-o" aria-hidden="true"></i>
                               <br />
                                No Data Stored -->
                                Please Stand By<br />
                                We are looking for your next job<br />
                                Check Back Soon<br />
                            </div>
                        </div>  
                    </div>  

                </div>

            </div>
            <!-- /Individual calls section area -->


        </div>
        <!-- /Individual calls section area -->
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import dateTimeConvert from '../../timeConvert&Compare';
    import service from '../../services.js';
    export default {
        props: {
            scheduleData:{
                type: Object,
                required:true
            },
            userSelectMonth: {
                type: String,
                required: true
            },
             userDateFormat: {
                type: String,
                required:false
            },
            userTimeFormat: {
                type: String,
                required:false
            },
        },
        watch: {
            // userSelectMonth: function(newData) {
            //     //console.log(newData);
            //     this.scheduleList = [];
            //     //console.log(this)
            //     this.selectedMonth = moment(newData).month()+1;//newData.getMonth() + 1;
            //     this.selectedYear = moment(newData).year(); //newData.getFullYear();
            //     //console.log("Data",this.selectedMonth,this.selectedYear);
            //     this.getMonthDeclinedCalls();
            // },
            scheduleData: function(newData){
                this.scheduleList = [];
                if(newData.subTab=='month'){
                    this.selectedMonth = moment(newData.month).month()+1;//newData.getMonth() + 1;
                    this.selectedYear = moment(newData.month).year(); //newData.getFullYear();
                    this.getMonthDeclinedCalls();
                }else{
                    this.getNext45DaysDeclinedCalls();
                }
                // console.log(newData);
            },
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                userID: 'userID',
            })
        },
        data() {
            return {
                loading:false,
                afterAPI:false,
                declinedList: [],
                selectedMonth: moment().month()+1,//new Date().getMonth() + 1,
                selectedYear: moment().year(),//new Date().getFullYear(),
            }
        },
        methods: {
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            undeclinedCall(call) {
                service.post('call/undecline', {
                    'employee_id': atob(this.$route.params.empId),
                    'call_id': call.call.id,
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    this.$Progress.finish();
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call undeclined successfully.',
                        type: 'success'
                    });
                    this.getMonthDeclinedCalls();
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                });
                this.getMonthDeclinedCalls();
            },
            getDate(str) {
                return dateTimeConvert.localDate(str,this.userDateFormat);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime,this.userTimeFormat);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time= dateTimeConvert.convertTo12Hours(time);
                //return time;
            },

            getGlobalDateTimeFormat(data) {
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },
            getTS(dateTime){
                return dateTimeConvert.utcTimeToUserTime(dateTime);
            },
            getMonthDeclinedCalls() {
                this.$Progress.start();
                this.loading=true;
                this.afterAPI=false;
                service.get('call/employeeDeclinedCallsByMonth', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': atob(this.$route.params.empId),
                    'month': this.selectedMonth,
                    'year': this.selectedYear,
                }).
                then((res) => {
                    this.declinedList = res.data.result;
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                    //console.log(this.declinedList);
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                    this.afterAPI=true;
                });
            },
            getNext45DaysDeclinedCalls() {
                this.$Progress.start();
                this.loading=true;
                this.afterAPI=false;
                service.get('call/employeeDeclinedCallsByNext45', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': atob(this.$route.params.empId),
                    // 'month': this.selectedMonth,
                    'year': this.selectedYear,
                }).
                then((res) => {
                    this.declinedList = res.data.result;
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                    //console.log(this.declinedList);
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                    this.afterAPI=true;
                });
            }
            // getDate(dateTime){
            //     var date = dateTimeConvert.extractDateOnly(dateTime);
            //     return dateTimeConvert.extractDateOnly(dateTime);
            // },

        },
        created() {
            //console.log(this.selectedYear, this.selectedMonth);
            //console.log(this.userSelectMonth.getMonth() + 1)
            this.selectedMonth =moment(this.userSelectMonth).month()+1; // this.userSelectMonth.getMonth() + 1;
            this.selectedYear = moment(this.userSelectMonth).year(); //this.userSelectMonth.getFullYear();
            // this.getMonthDeclinedCalls();
            // this.getNext45DaysDeclinedCalls();

            if(this.scheduleData.subTab=='month'){
                this.getMonthDeclinedCalls();
            }else{
                this.getNext45DaysDeclinedCalls();
            }
        }
    }

</script>
